import script from "./InputRangeMultiCollateral.vue?vue&type=script&setup=true&lang=js"
export * from "./InputRangeMultiCollateral.vue?vue&type=script&setup=true&lang=js"

import "./InputRangeMultiCollateral.vue?vue&type=style&index=0&id=0a1eec88&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a1eec88"]])

export default __exports__